import React, { FunctionComponent } from 'react';
import { Table, TableRow, TableBody, TableCell, TableHead, Typography } from '@mui/material';
import { StringFormatter } from '../../../../utils';
import { ISummaryReport } from '../../../../interfaces/calculator.interface';
import { useStyles, useTableCellStyles } from './TotalSavings.styles';

interface IProps{
  report: ISummaryReport;
}

const TotalSavingsByPopulation: FunctionComponent<IProps> = ({ report }) => {
  const classes = useStyles();
  const tableClasses = useTableCellStyles();
  const tableRows = [
    {
      titleClass: classes.columnTitle,
      title: 'Children',
      firstAmountClass: classes.sectionAmount,
      firstAmount: StringFormatter.roundedMoney(report?.totalSavingsByChild?.toString() || '0'),
      secondAmountClass: classes.sectionAmount,
      secondAmount: StringFormatter.interventionPercentage(report?.totalSavingsChildPercentage?.toString() || '0'),
      visible: true,
    },
    {
      titleClass: classes.sectionTitle,
      title: 'Adults',
      firstAmountClass: classes.sectionAmount,
      firstAmount: StringFormatter.roundedMoney(report?.totalSavingsByAdult?.toString() || '0'),
      secondAmountClass: classes.sectionAmount,
      secondAmount: StringFormatter.interventionPercentage(
        report?.totalSavingsAdultPercentage?.toString() || '0'
      ),
      visible: true,
    },
    {
      titleClass: classes.subsectionTitle,
      title: 'Total',
      firstAmountClass: classes.subsectionAmount,
      firstAmount: StringFormatter.roundedMoney(
        report?.totalSavingsByPopulation?.toString() || '0'
      ),
      secondAmountClass: classes.subsectionAmount,
      secondAmount: StringFormatter.interventionPercentage(
        report?.totalSavingsPopulationPercentage?.toString() || '0'
      ),
      visible: true,
    },
  ];
  return (
    <div>
      <Typography variant="h2" className={classes.contentTitle}>Total Savings by Population</Typography>
      <Table className={classes.tableContainer}>
        <TableHead>
          <TableCell className={classes.tableHead} align="left">
            Population
          </TableCell>
          <TableCell className={classes.tableHead} align="center">
            $
          </TableCell>
          <TableCell className={classes.tableHead} align="center">
            %
          </TableCell>
        </TableHead>
        <TableBody>
          {tableRows.map((row, idx) => (
            row.visible ?
              <TableRow key={idx}>
                <TableCell component="th" scope="row" className={tableClasses.cell}>
                  {row.title}
                </TableCell>
                <TableCell className={`${row.firstAmountClass} ${tableClasses.cell}`} align="right">
                  {row.firstAmount}
                </TableCell>
                <TableCell className={`${row.secondAmountClass}  ${tableClasses.cell}`} align="right">
                  {row.secondAmount}
                </TableCell>
              </TableRow>
              : <></>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TotalSavingsByPopulation;
